import { usePunditUserContext } from "@circle-react/contexts";
import { communitySignInUrl } from "@circle-react/helpers/communityHelpers";

const communitySignUpUrl = (community: any) => {
  if (!community) return null;
  const signupUrl = "/sign_up";
  const {
    private_sign_up_url: customSignUpUrl,
    is_private: isPrivateCommunity,
    allow_signups_to_public_community: areSignupsAllowed,
  } = community;
  const canUsersSignUp =
    (!isPrivateCommunity && areSignupsAllowed) ||
    (isPrivateCommunity && !!customSignUpUrl);
  const userSignUpUrl = customSignUpUrl || signupUrl;

  return canUsersSignUp ? userSignUpUrl : null;
};

export const useSignInUrl = () => {
  const { currentCommunity, currentUser, currentCommunityMember } =
    usePunditUserContext();

  const signUpUrl = communitySignUpUrl(currentCommunity);
  const signInUrl = currentCommunity
    ? communitySignInUrl(currentCommunity, {
        post_login_redirect: window.location.href,
      })
    : null;
  const isSignUpRequired = currentUser && !currentCommunityMember;
  const url = isSignUpRequired ? signUpUrl : signInUrl;
  const canSignIn = !!url;

  const redirectToUrl = () => {
    if (!canSignIn) return;
    window.location.href = url;
  };

  return {
    canSignIn,
    url,
    redirectToUrl,
  };
};
